<template>
    <v-container style="margin: 60px 10%">
      <vueHeadful
      :title="this.$i18n.t('Menu.AdministracionManual') + ' - TrArtist'"
      :url="'https://trartist.com' + $route.fullPath"
      />
        <v-row>
          <v-col cols="12" align="center">
            <h1>{{$t('Formularios.Bienvenido')}}</h1>
          </v-col>
          <v-col cols="12" align="center">
            <v-btn :to="$t('Alias.CapacitacionOficina')" color="black white--text" x-large>{{$t('Formularios.VerPagina')}}</v-btn>
          </v-col>
          <v-col cols="12" align="center">
            <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.DescripcionEs') }}</h2>
            <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
            <vue-editor id="descripcionEs" v-model="bienvenido.descripcionEs" useCustomImageHandler @image-added="handleImageAdded" />
          </v-col>
          <v-col cols="12" align="center">
            <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.DescripcionEn') }}</h2>
            <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
            <vue-editor id="descripcionEn" v-model="bienvenido.descripcionEn" useCustomImageHandler @image-added="handleImageAdded" />
          </v-col>
          <v-col cols="12">
            <v-dialog v-model="dialog">
              <v-card>
                <v-card-title>
                    <v-container>
                        <v-row>
                            <v-col cols="12" align="center">
                                <h1 v-if="nuevo">{{ $t('Formularios.NuevaSeccion') }}</h1>
                                <h1 v-else>{{ $t('Formularios.EditarSeccion') }}</h1>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field solo v-model="nuevaSeccion.tituloEs" :label="$t('Formularios.TituloEs')" :hint="$t('Formularios.TituloEs')" persistent-hint />
                            </v-col>
                            <v-col cols="12">
                                <v-text-field solo v-model="nuevaSeccion.tituloEn" :label="$t('Formularios.TituloEn')" :hint="$t('Formularios.TituloEn')" persistent-hint />
                            </v-col>
                            <v-col cols="12" align="center">
                                <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.DescripcionEs') }}</h2>
                                <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
                                <vue-editor id="descripcionEs" v-model="nuevaSeccion.descripcionEs" useCustomImageHandler @image-added="handleImageAdded" />
                            </v-col>
                            <v-col cols="12" align="center">
                                <h2 class="my-5 headline vietnam black--text">{{ $t('Formularios.DescripcionEn') }}</h2>
                                <v-alert v-if="getCargandoAccion"><v-btn loading text color="error"></v-btn>{{ $t('Formularios.CargandoImagen') }}</v-alert>
                                <vue-editor id="descripcionEn" v-model="nuevaSeccion.descripcionEn" useCustomImageHandler @image-added="handleImageAdded" />
                            </v-col>
                            <v-col cols="12" align="center">
                                <v-btn outlined style="border:2px solid" color="black" x-large class="ma-3" @click="dialog = false">Cerrar</v-btn>
                                <v-btn class="ma-3" v-if="nuevo" color="black white--text" style="min-width:20%!important" x-large @click="publicarNuevaSeccion()" :loading="getCargandoAccion">{{$t('Formularios.Publicar')}}</v-btn>
                                <v-btn class="ma-3" v-else color="black white--text" style="min-width:20%!important" x-large @click="actualizarSeccion()" :loading="getCargandoAccion">{{$t('Formularios.Actualizar')}}</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-title>
            </v-card>
            </v-dialog>
            <v-data-table
            :headers="headers"
            :items="secciones"
            disable-sort
            id="secciones"
            ref="sortableTable">
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>{{ $t('Formularios.Secciones') }}</v-toolbar-title>
                    <v-divider
                    class="mx-4"
                    inset
                    vertical
                    ></v-divider>
                    <v-spacer></v-spacer>
                    <v-btn color="black white--text" @click="abrirDialog('nuevo')">{{ $t('Formularios.NuevaSeccion') }}</v-btn>
                </v-toolbar>
            </template>
            <template v-slot:body="{ items }">
              <tbody>
                <tr class="sortableRow" v-for="(item) in items" :key="itemKey(item)">
                  <td class="sortHandle">
                    <v-btn icon style="cursor: move" class="handle"><v-icon>fas fa-grip-lines</v-icon></v-btn>
                  </td>
                  <td class="text-xs-center">
                    <span v-if="getIdioma === 'es'" class="handle">{{ item.tituloEs }}</span>
                    <span v-else class="handle">{{ item.tituloEn }}</span>
                  </td>
                  <td class="text-xs-center">
                    <v-icon class="mx-2" color="black" @click="abrirDialog('editar', item)">far fa-edit</v-icon>
                    <v-icon class="mx-2" color="black" @click="eliminar(item)">far fa-trash-alt</v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
            </v-data-table>
          </v-col>
          <v-col cols="12" align="center">
            <v-btn color="black white--text" style="min-width:20%!important" x-large @click="actualizarBienvenido()" :loading="getCargandoAccion">{{$t('Formularios.Actualizar')}}</v-btn>
          </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { VueEditor } from 'vue2-editor'
import { mapMutations, mapGetters } from 'vuex'
import axios from 'axios'
import Sortable from 'sortablejs'
export default {
  name: 'AdministracionManual',
  components: {
    VueEditor
  },
  data () {
    return {
      itemKeys: new WeakMap(),
      currentItemKey: 0,
      dialog: false,
      nuevo: false,
      index: null,
      headers: [
        { text: '', value: 'sort' },
        { text: this.$i18n.t('Formularios.Titulo'), value: 'titulo' },
        { text: this.$i18n.t('Formularios.Acciones'), value: 'acciones' }
      ],
      nuevaSeccion: {
        tituloEs: null,
        tituloEn: null,
        descripcionEs: null,
        descripcionEn: null
      },
      bienvenido: [],
      secciones: []
    }
  },
  computed: {
    ...mapGetters(['getCargandoAccion', 'getIdioma'])
  },
  methods: {
    ...mapMutations(['setAlerta', 'setTextoAlerta', 'setCargandoAccion']),
    itemKey (item) {
      if (!this.itemKeys.has(item)) { this.itemKeys.set(item, ++this.currentItemKey) }
      return this.itemKeys.get(item)
    },
    abrirDialog (tipo, info) {
      if (tipo === 'nuevo') {
        this.nuevaSeccion = {
          tituloEs: null,
          tituloEn: null,
          descripcionEs: null,
          descripcionEn: null
        }
        this.nuevo = true
        this.dialog = true
      } else {
        this.index = this.secciones.indexOf(info)
        this.nuevaSeccion = {
          tituloEs: info.tituloEs,
          tituloEn: info.tituloEn,
          descripcionEs: info.descripcionEs,
          descripcionEn: info.descripcionEn
        }
        this.nuevo = false
        this.dialog = true
      }
    },
    publicarNuevaSeccion () {
      this.setCargandoAccion(true)
      this.secciones.push(this.nuevaSeccion)
      firebase.firestore().collection('utilidades').doc('manual').update({
        secciones: this.secciones
      })
        .then(() => {
          this.setAlerta()
          this.setTextoAlerta('Alerta.InformacionPublicada')
          this.setCargandoAccion(false)
          this.dialog = false
        })
    },
    actualizarSeccion () {
      this.setCargandoAccion(true)
      this.secciones[this.index].tituloEs = this.nuevaSeccion.tituloEs
      this.secciones[this.index].tituloEn = this.nuevaSeccion.tituloEn
      this.secciones[this.index].descripcionEs = this.nuevaSeccion.descripcionEs
      this.secciones[this.index].descripcionEn = this.nuevaSeccion.descripcionEn
      firebase.firestore().collection('utilidades').doc('manual').update({
        secciones: this.secciones
      })
        .then(() => {
          this.setAlerta()
          this.setTextoAlerta('Alerta.InformacionActualizada')
          this.setCargandoAccion(false)
          this.dialog = false
        })
    },
    actualizarBienvenido () {
      firebase.firestore().collection('utilidades').doc('manual').update({
        bienvenido: this.bienvenido,
        secciones: this.secciones
      })
        .then(() => {
          this.setAlerta()
          this.setTextoAlerta('Alerta.InformacionActualizada')
        })
    },
    eliminar (item) {
      var index = this.secciones.indexOf(item)
      this.secciones.splice(index, 1)
      firebase.firestore().collection('utilidades').doc('manual').update({
        secciones: this.secciones
      })
        .then(() => {
          this.setAlerta()
          this.setTextoAlerta('Alerta.InformacionEliminada')
        })
    },
    handleImageAdded (file, Editor, cursorLocation, resetUploader) {
      this.setCargandoAccion(true)
      this.subirImagen(file).then(url => {
        Editor.insertEmbed(cursorLocation, 'image', url)
        resetUploader()
        this.setCargandoAccion(false)
      })
    },
    subirImagen (file) {
      const reader = new FileReader()
      return new Promise(resolve => {
        reader.onload = ev => {
          axios({
            method: 'post',
            url: '/subir',
            crossDomain: true,
            data: {
              image: ev.target.result,
              tipo: 'sinMarca'
            }
          })
            .then(respuesta => {
              fetch(respuesta.data).then(res => res.blob()).then(blob => {
                var uploadTask = firebase.storage().ref('utilidades').child(file.name).put(blob)
                uploadTask.on('state_changed', snapshot => {}, error => {
                  console.log(error)
                }, () => {
                  uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
                    axios({
                      method: 'post',
                      url: '/eliminar',
                      crossDomain: true,
                      data: {
                        url: respuesta.data
                      }
                    })
                    resolve(downloadURL)
                  })
                })
              })
            })
            .catch(error => {
              console.log(error)
            })
        }
        reader.readAsDataURL(file)
      })
    },
    reorganizar () {
      const _self = this
      Sortable.create(_self.$refs.sortableTable.$el.getElementsByTagName('tbody')[0], {
        handle: '.handle',
        draggable: '.sortableRow',
        onEnd ({ newIndex, oldIndex }) {
          _self.secciones.splice(newIndex, 0, ..._self.secciones.splice(oldIndex, 1))
        }
      })
    }
  },
  mounted () {
    firebase.firestore().collection('utilidades').doc('manual').get().then(info => {
      this.secciones = info.data().secciones
      this.bienvenido = info.data().bienvenido
      this.$nextTick(() => {
        this.reorganizar()
      })
    })
  }
}
</script>
